<template>
  <div>
    <el-card>
      <div class="menu-box">
        <h2>订单管理</h2>
        <div class="box-bd">
          <!-- 搜索栏 -->
          <el-row type="flex" :gutter="12" class="search-bar">
            <el-col :span="5">
              <el-input
                size="small"
                clearable
                placeholder="预订人姓名"
                prefix-icon="el-icon-user"
                v-model="query.customer"
                @keyup.enter.native="getList"
              />
            </el-col>
            <el-col :span="6">
              <el-input
                size="small"
                clearable
                placeholder="订单编号"
                prefix-icon="el-icon-document"
                v-model="query.order_no"
                @keyup.enter.native="getList"
              />
            </el-col>
            <el-col :span="5">
              <el-input
                size="small"
                clearable
                placeholder="联系电话"
                prefix-icon="el-icon-phone"
                v-model="query.phone"
                @keyup.enter.native="getList"
              />
            </el-col>
            <el-col :span="4">
              <el-select
                size="small"
                clearable
                v-model="query.status"
                placeholder="订单状态"
                style="width:100%"
              >
                <el-option label="已预订" :value="0" />
                <el-option label="已入住" :value="2" />
                <el-option label="已完成" :value="3" />
                <el-option label="已取消" :value="1" />
              </el-select>
            </el-col>
            <el-col :span="5">
              <el-date-picker
                size="small"
                v-model="query.create_time"
                type="date"
                placeholder="下单日期"
                value-format="yyyy-MM-dd"
                style="width:100%"
              />
            </el-col>
          </el-row>
          <el-row type="flex" justify="end" style="margin-bottom:12px;margin-top:6px;">
            <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查 询</el-button>
            <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重 置</el-button>
          </el-row>

          <!-- 统计卡片 -->
          <el-row :gutter="16" class="stat-row">
            <el-col :span="6">
              <div class="stat-card all">
                <div class="stat-num">{{ stats.total }}</div>
                <div class="stat-label">全部订单</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card pending">
                <div class="stat-num">{{ stats.pending }}</div>
                <div class="stat-label">已预订</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card checkin">
                <div class="stat-num">{{ stats.checkin }}</div>
                <div class="stat-label">已入住</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card done">
                <div class="stat-num">{{ stats.done }}</div>
                <div class="stat-label">已完成</div>
              </div>
            </el-col>
          </el-row>

          <!-- 订单表格 -->
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            border
            stripe
            row-key="order_id"
            style="width:100%;margin-top:10px;"
          >
            <el-table-column type="expand">
              <template v-slot="scope">
                <div class="expand-box">
                  <el-row :gutter="20" style="margin-bottom:10px;">
                    <el-col :span="8"><b>规格：</b>{{ scope.row.list && scope.row.list[0] ? scope.row.list[0].spec_key_name : '-' }}</el-col>
                    <el-col :span="8"><b>房间：</b>{{ scope.row.list && scope.row.list[0] ? scope.row.list[0].room_name : '-' }}</el-col>
                    <el-col :span="8"><b>单价：</b>¥{{ scope.row.list && scope.row.list[0] ? scope.row.list[0].price : '-' }}</el-col>
                  </el-row>
                  <el-row :gutter="20" style="margin-bottom:10px;">
                    <el-col :span="8"><b>入住时间：</b>{{ scope.row.start_time || '-' }}</el-col>
                    <el-col :span="8"><b>离店时间：</b>{{ scope.row.end_time || '-' }}</el-col>
                    <el-col :span="8"><b>下单时间：</b>{{ scope.row.create_time || '-' }}</el-col>
                  </el-row>
                  <div v-if="scope.row.list && scope.row.list[0] && scope.row.list[0].check_list && scope.row.list[0].check_list.length > 0">
                    <div style="font-weight:bold;margin-bottom:6px;">入住人员信息：</div>
                    <el-table border :data="scope.row.list[0].check_list" size="mini">
                      <el-table-column label="入住ID" prop="check_in_id" width="90"></el-table-column>
                      <el-table-column label="姓名" prop="customer"></el-table-column>
                      <el-table-column label="身份证号" prop="id_number"></el-table-column>
                    </el-table>
                  </div>
                  <div v-else style="color:#999;font-size:13px;">暂无入住人员信息</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="order_no" label="订单号" min-width="200" show-overflow-tooltip />
            <el-table-column prop="customer" label="预订人" width="100" />
            <el-table-column prop="phone" label="手机号" width="140" />
            <el-table-column label="类型" width="90" align="center">
              <template v-slot="scope">
                <el-tag size="small" type="success" v-if="scope.row.type === 0">全天房</el-tag>
                <el-tag size="small" type="warning" v-else-if="scope.row.type === 1">钟点房</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="订单金额" width="110" align="center">
              <template v-slot="scope">
                <span class="price-text">¥{{ scope.row.price }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="number" label="入住人数" width="90" align="center" />
            <el-table-column label="状态" width="90" align="center">
              <template v-slot="scope">
                <el-tag size="small" v-if="scope.row.status === 0" type="warning">已预订</el-tag>
                <el-tag size="small" v-else-if="scope.row.status === 2" type="">已入住</el-tag>
                <el-tag size="small" v-else-if="scope.row.status === 3" type="success">已完成</el-tag>
                <el-tag size="small" v-else-if="scope.row.status === 1" type="info">已取消</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="下单时间" min-width="160" show-overflow-tooltip />
            <el-table-column label="操作" width="240" fixed="right">
              <template v-slot="scope">
                <el-button size="mini" icon="el-icon-search" @click="openDetail(scope.row)">详情</el-button>
                <el-button
                  v-if="scope.row.status === 0"
                  size="mini"
                  type="primary"
                  icon="el-icon-edit-outline"
                  @click="pAdd(scope.row)"
                >录入</el-button>
                <el-button
                  v-if="scope.row.status === 2"
                  size="mini"
                  type="warning"
                  icon="el-icon-house"
                  @click="doCheckout(scope.row)"
                >退房</el-button>
                <el-button
                  v-if="scope.row.status === 0"
                  size="mini"
                  type="danger"
                  icon="el-icon-close"
                  @click="cancelOrder(scope.row)"
                >取消</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <el-pagination
            class="pagination"
            :pager-count="7"
            @current-change="pageChange"
            @size-change="sizeChange"
            :page-sizes="[7, 15, 20, 50]"
            layout="total, sizes, prev, pager, next, jumper"
            :page-size="query.limit"
            background
            :total="exp.total"
          />
        </div>
      </div>
    </el-card>

    <!-- 录入入住信息弹窗 -->
    <el-dialog
      v-dialogDrag
      title="录入入住信息"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="formClose"
    >
      <el-row style="margin-bottom:12px;">
        <el-button type="success" size="mini" icon="el-icon-plus" @click="addInfo">添加人员</el-button>
      </el-row>
      <el-table :data="form.customer_info" border size="small">
        <el-table-column label="客户姓名" prop="customer">
          <template v-slot="scope">
            <el-input
              size="mini"
              placeholder="请填写姓名"
              @change="handleChange"
              v-model="scope.row.customer"
            />
          </template>
        </el-table-column>
        <el-table-column label="身份证号" prop="id_number" width="200">
          <template v-slot="scope">
            <el-input
              size="mini"
              placeholder="请填写身份证号"
              @change="handleChange"
              v-model="scope.row.id_number"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="70">
          <template v-slot="scope">
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="delInfo(scope.$index)" />
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelAE">取 消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="confirmAE">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 订单详情弹窗 -->
    <el-dialog
      v-dialogDrag
      title="订单详情"
      :visible.sync="detailVisible"
      width="720px"
    >
      <div v-if="detailInfo" class="detail-box">
        <el-descriptions :column="2" border size="small" class="detail-desc">
          <el-descriptions-item label="订单号">{{ detailInfo.order_no }}</el-descriptions-item>
          <el-descriptions-item label="订单状态">
            <el-tag size="small" v-if="detailInfo.status === 0" type="warning">已预订</el-tag>
            <el-tag size="small" v-else-if="detailInfo.status === 2">已入住</el-tag>
            <el-tag size="small" v-else-if="detailInfo.status === 3" type="success">已完成</el-tag>
            <el-tag size="small" v-else-if="detailInfo.status === 1" type="info">已取消</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="预订人">{{ detailInfo.customer }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ detailInfo.phone }}</el-descriptions-item>
          <el-descriptions-item label="入住人数">{{ detailInfo.number }} 人</el-descriptions-item>
          <el-descriptions-item label="订单金额">
            <span class="price-text">¥{{ detailInfo.price }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="房型">
            <el-tag size="small" v-if="detailInfo.type === 0" type="success">全天房</el-tag>
            <el-tag size="small" v-else-if="detailInfo.type === 1" type="warning">钟点房</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="下单时间">{{ detailInfo.create_time }}</el-descriptions-item>
          <el-descriptions-item label="入住时间">{{ detailInfo.start_time }}</el-descriptions-item>
          <el-descriptions-item label="离店时间">{{ detailInfo.end_time }}</el-descriptions-item>
        </el-descriptions>

        <div style="margin-top:18px;" v-if="detailInfo.list && detailInfo.list.length > 0">
          <div class="section-title">房间信息</div>
          <el-table :data="detailInfo.list" border size="small" style="margin-top:8px;">
            <el-table-column label="分组" prop="group_name" />
            <el-table-column label="房间" prop="room_name" />
            <el-table-column label="规格" prop="spec_key_name" />
            <el-table-column label="价格" prop="price">
              <template v-slot="scope">¥{{ scope.row.price }}</template>
            </el-table-column>
          </el-table>
        </div>

        <div
          style="margin-top:18px;"
          v-if="detailInfo.list && detailInfo.list[0] && detailInfo.list[0].check_list && detailInfo.list[0].check_list.length > 0"
        >
          <div class="section-title">入住人员</div>
          <el-table :data="detailInfo.list[0].check_list" border size="small" style="margin-top:8px;">
            <el-table-column label="入住ID" prop="check_in_id" width="90" />
            <el-table-column label="姓名" prop="customer" />
            <el-table-column label="身份证号" prop="id_number" />
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import lodash from 'lodash'
import {
  getOrderList,
  orderInfo,
  checkin,
  checkout,
  cancelOrder,
} from '@/api/room/roomstatemanage.js'

export default {
  name: 'OrderList',
  data() {
    return {
      price_id: '',
      isEdit: false,
      tableLoading: false,
      exp: {
        total: 0,
      },
      btnLoading: false,
      stats: {
        total: 0,
        pending: 0,
        checkin: 0,
        done: 0,
      },
      query: {
        page: 1,
        page_code: '',
        limit: 15,
        order_no: '',
        customer: '',
        phone: '',
        create_time: '',
        status: '',
      },
      dialogVisible: false,
      detailVisible: false,
      detailInfo: null,
      form: {
        order_id: '',
        customer_info: [],
      },
      tableData: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleSearch() {
      this.query.page = 1
      this.getList()
    },
    resetQuery() {
      this.query = {
        page: 1,
        page_code: '',
        limit: 15,
        order_no: '',
        customer: '',
        phone: '',
        create_time: '',
        status: '',
      }
      this.getList()
    },
    pageChange(val) {
      this.query.page = val
      this.getList()
    },
    sizeChange(val) {
      this.query.limit = val
      this.query.page = 1
      this.getList()
    },
    async getList() {
      this.tableLoading = true
      try {
        const { data: res } = await getOrderList(this.query)
        if (res.code === 1) {
          this.tableData = res.data || []
          this.exp.total = res.exp ? res.exp.num : 0
          this.calcStats()
        } else {
          this.$message.error(res.message || '获取数据失败！')
        }
      } catch (e) {
        this.$message.error('请求失败，请稍后重试')
      }
      this.tableLoading = false
    },
    calcStats() {
      // 当前页统计（如需全局统计可单独请求接口）
      this.stats.total = this.exp.total
      let pending = 0, checkin = 0, done = 0
      this.tableData.forEach((item) => {
        if (item.status === 0) pending++
        else if (item.status === 2) checkin++
        else if (item.status === 3) done++
      })
      this.stats.pending = pending
      this.stats.checkin = checkin
      this.stats.done = done
    },
    // 打开详情
    async openDetail(row) {
      try {
        const { data: res } = await orderInfo({ order_id: row.order_id })
        if (res.code === 1) {
          this.detailInfo = res.data
          this.detailVisible = true
        } else {
          this.$message.error(res.message || '获取详情失败')
        }
      } catch (e) {
        this.$message.error('请求失败')
      }
    },
    // 录入入住信息 - 打开
    pAdd(row) {
      this.dialogVisible = true
      this.form.order_id = row.order_id
      this.price_id = row.list && row.list[0] ? row.list[0].price_id : ''
      if (this.form.customer_info.length === 0) {
        this.form.customer_info.push({
          price_id: this.price_id,
          customer: '',
          id_number: '',
        })
      }
    },
    addInfo() {
      this.form.customer_info.push({
        price_id: this.price_id,
        customer: '',
        id_number: '',
      })
    },
    delInfo(index) {
      this.form.customer_info.splice(index, 1)
    },
    handleChange() {
      this.isEdit = true
    },
    formClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          this.cancelAE()
          done && done()
        })
        .catch(() => {})
    },
    cancelAE() {
      this.isEdit = false
      this.form = { order_id: '', customer_info: [] }
      this.dialogVisible = false
    },
    // 退房
    doCheckout(row) {
      this.$confirm(`确认为「${row.customer}」办理退房？`, '退房确认', {
        type: 'warning',
        confirmButtonText: '确认退房',
        cancelButtonText: '取消',
      })
        .then(async () => {
          let f = new FormData()
          f.append('room_id', row.list[0].room_id)
          f.append('price_id', row.list[0].price_id)
          const { data: res } = await checkout(f)
          if (res.code === 1) {
            this.$message.success('退房成功！')
            this.getList()
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {})
    },
    // 取消订单
    cancelOrder(row) {
      this.$confirm(`确认取消订单「${row.order_no}」？`, '取消订单', {
        type: 'warning',
        confirmButtonText: '确认取消',
        cancelButtonText: '返回',
      })
        .then(async () => {
          const { data: res } = await cancelOrder({ order_id: row.order_id })
          if (res.code === 1) {
            this.$message.success('订单已取消')
            this.getList()
          } else {
            this.$message.error(res.message || '取消失败')
          }
        })
        .catch(() => {})
    },
    // 确认录入
    async confirmAE() {
      const invalidItem = this.form.customer_info.find(
        (item) => !item.customer || !item.id_number
      )
      if (invalidItem) {
        this.$message.warning('请填写完整的姓名和身份证号！')
        return
      }
      let query = lodash.cloneDeep(this.form)
      query.customer_info = JSON.stringify(query.customer_info)
      var formData = new FormData()
      for (let key in query) {
        formData.append(key, query[key])
      }
      this.btnLoading = true
      try {
        const { data: res } = await checkin(formData)
        if (res.code === 1) {
          this.$message.success('录入成功')
          this.getList()
          this.cancelAE()
        } else {
          this.$message.error(res.message)
        }
      } catch (e) {
        this.$message.error('请求失败')
      }
      this.btnLoading = false
    },
  },
}
</script>

<style scoped>
.search-bar {
  margin-bottom: 0;
  flex-wrap: wrap;
}
.stat-row {
  margin: 14px 0 8px 0;
}
.stat-card {
  border-radius: 8px;
  padding: 14px 18px;
  text-align: center;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.stat-card.all { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
.stat-card.pending { background: linear-gradient(135deg, #f7971e 0%, #ffd200 100%); }
.stat-card.checkin { background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); }
.stat-card.done { background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%); }
.stat-num {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
}
.stat-label {
  font-size: 13px;
  margin-top: 4px;
  opacity: 0.9;
}
.price-text {
  color: #f56c6c;
  font-weight: 600;
}
.pagination {
  margin-top: 14px;
  text-align: right;
}
.expand-box {
  padding: 8px 20px 4px 20px;
  background: #fafafa;
}
.detail-box {
  padding: 0 4px;
}
.detail-desc {
  margin-bottom: 4px;
}
.section-title {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  border-left: 3px solid #409EFF;
  padding-left: 8px;
}
</style>
